import * as React from 'react';
import classNames from 'classnames';
import { compose } from 'redux';
import withStyles, { WithStyles } from 'react-jss';

import './styles.scss';

export interface ITimeRemainingProps {
}

interface IState {
}

type Props = ITimeRemainingProps & WithStyles<typeof styles>;

/**
 * Displays time remaining information
 */
class TimeRemaining extends React.Component<Props, IState> {
        static displayName: string = 'TimeRemaining';
    
    render () {
        return (
            <div className={classNames('time-remaining', this.props.classes.timeremaining)}>
                <div className="time-remaining-limiter">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

const styles = (theme) => {
    return {
        timeremaining: {
            'backgroundColor': theme.colors.gray.lighter,
            '& B': {
                color: theme.colors.sum,
            },
        },
    };
};

export default compose<React.ComponentClass<ITimeRemainingProps>>(
    withStyles(styles, { injectTheme: true })
)(TimeRemaining);
